import Form from "../form/Form.js";
import Testimonial from "../testimonial/Testimonial.js";
import Feature from "../features/Feature.js";
import BecomeProfessional from "../becomeprofessional/BecomeProfessional.js";
import TrackTimeline from "../tracksyllabus/TrackTimeline.js";
import "./Main.css";
import LearningEnvironment from "../learningenv/LearnEnvironment.js";
import WhyChooseGeegStack from "../whychoosegeegstack/WhyChooseGeegStack.js";
import CareerSupport from "../careersupport/CareerSupport.js";
import Faq from "../faq/Faq.js";
import Pricing from "../pricing/Pricing.js";
import { useState } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationDot } from "@fortawesome/free-solid-svg-icons";
import { faCalendarDays } from "@fortawesome/free-solid-svg-icons";
import { faClock } from "@fortawesome/free-solid-svg-icons";
import { faCalendar } from "@fortawesome/free-solid-svg-icons";
import whatsAppIcon from "../images/WhatsApp_icon.png";


export default function Main() {
  let track = "Fullstack";
  let duration = "20 Weeks";
  let content =
    "Whether you have experience writing programming before or you are just starting out with no coding experience, we will hold your hands through and give you all the necessary skill set you need to become a job ready developer. Within the 24 weeks, you will learn about the foundation- how the internet works, how programs work and start to write your own programs. You will learn to build the interface of software applications and web pages then learn to build robustic web servers using the most in demand technologies like JavaScript, React, NodeJS, ExpressJS, MongoDB. You will also learn the strategies to get your first paid job or project as a graduate student developer and get necessary support";
  let tracks = [
    {
      header: "Fundamentals",
      content:
        "Fundamentals: The first few weeks of the program helps you get started in programming –how the internet works, how programs work, the essential tools needed to become a successful developer and then learning the basic web languages- html and css. After which you’ll be able to develop the interface of websites and software that displays well on any device - desktop, tab or mobile phon",
    },
    {
      header: "Frontend programming",
      content:
        "After the basics, we will dive deep into the web's most popular programming language- JavaScript. We’ll start with the basics up to building standard responsive applications with it",
    },
    {
      header: "Version Control System",
      content:
        "You will learn to track different code versions as we work on projects and how we can collaborate with others to successfully work on a project and contribute to others projects. We’ll be using Git and GitHub for this.",
    },
    {
      header: "Frontend Library",
      content:
        "You will learn to build standard single page applications and create reusable components using the most popular JavaScript library- React.",
    },
    {
      header: "AI Tools",
      content:
        "The course is AI Driven. You will learn to build build, debug and ship faster and smarter using AI coding tools and assistants like Claude, v0.dev, Cursor IDE, Github Copilot among others.",
    },
    {
      header: "Serverside",
      content:
        " You’ll learn to build dynamic web pages that render contents based on the user's previous interactions with it. The same logic used to build Facebook, Twitter, Blogs and other web projects. You will be able to do this with NodeJS and its framework, ExpressJS.",
    },
    {
      header: "Database",
      content:
        " You will learn the fundamentals of database, key metrics to determine which database to use for a project and then learn to keep data used in your applications in database. In the program you’ll learn about MongoDB, the most used NoSQL database.",
    },
    {
      header: "Web hosting",
      content:
        " Having completed the development learning process, you will learn to host your projects live to be accessible to anyone on the internet.",
    },
  ];
  let faqs = [
    {
      header: "What will I accomplish at the end of the program?",
      content: [
        "At the end of the program, you would acquire the practical skills needed to build standard web based software applications and websites and be ready to be hired as a software developer.",
      ],
    },
    {
      header: "Will I work on projects during the course?",
      content: [
        "Yes, you will certainly work on practical real world projects during the course. Geegstack students work on average 15 projects during the program.",
      ],
    },

    {
      header: "Will Geegstack provide me with a job after the course?",
      content: [
        "We do not guarantee you a job immediately after the course, however, we will give you all the needed insights to secure your first paid job or gig after learning the course and refer you to opportunities when available.",
      ],
    },
    {
      header: "Can I pay in installment?",
      content: [
        "We recommend one time payment for an uninterrupted learning. For installment payment, 60% of the payment has to be made to start the course while the balance is paid before the mid of the course.",
      ],
    },
    {
      header:
        "I don’t have any coding experience before, can I join the program?",
      content: [
        "Yes, the program is beginner friendly. We are starting from the basics.",
      ],
    },
    {
      header: "What are the tools I need to join the class?",
      content: [
        "You need a PC with at least: 4G RAM, 128 HDD/SSD and 2 hours battery lifespan. All the needed software will be installed for you when the program starts.",
      ],
    },
    {
      header: "I don’t live in Ibadan, how can I join the class?",
      content: [
        "We have a conducive boarding facility with limited space for distance students who are interested. You can also consider the self-paced online classes.",
      ],
    },
  ];

  let pricing = [
    {
      header: "Boarding and Internship",
      price: "N450,000",
      duration: "7 months (4 months learning, 3 months Internship)",
      classDays: "Monday - Saturday",
      time: "9am - 6pm",
      Amenities: ["Adequate power supply", "Internet Access"],
    },
    {
      header: "Boarding Only",
      price: "N350,000",
      duration: "16weeks",
      classDays: "Monday - Saturday",
      time: "9am - 6pm",
      Amenities: ["Adequate power supply", "Internet Access"],
    },

    {
      header: "Week day Classes",
      price: "N205,000",
      duration: " 20 weeks",
      classDays: "Monday - Thursday",
      time: "9am - 3pm",
      Amenities: ["Adequate power supply", "Internet Access"],
    },
    {
      header: "Online Classes",
      price: "N175,000",
      duration: "Self Paced",
      classDays: "Everyday",
      time: "Anytime",
      Amenities: ["Self Paced", "Fulltime Support"],
    },
  ];
  const [showForm, setShowForm] = useState(false);

  function displayForm() {
    setShowForm(showFrom => !showForm);
  }
  
  return (
    <div className="main">
      {showForm &&
      <div style={{
        backgroundColor: "white",
        position: "fixed",
        width: "100vw",
        height: "100vh",
        top: 0,
        left: 0,
        zIndex: 20,
        opacity: 0.95,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}>
        <div className="cancel" onClick={() => setShowForm(false)}>
          <span className="bar first_bar"></span>
          <span className="bar third_bar"></span>
          <span className="bar second_bar"></span>
        </div>
        <Form customcss={true} course={"fullstack"}/>
      </div>
      }
      <a href="https://wa.me/2348050885112" className="ws-icon-link">
        <img src={whatsAppIcon} alt="WhatsApp" width={"50px"} />
      </a>
      <div className="course-info-regis-ctn">
        <div className="overlay"></div>
        <div className="course-info-regis-content">
          <CourseInfo
            courseName="Fullstack Development Professional Course"
            courseDescription="Acquire the skill sets you need to become an AI-Driven, job ready fullstack developer built for relevance in 2026 and beyond."
            duration={"20 weeks"}
            startDate={"April 20, 2026"}
            modes={"Weekday, Weekend, Boarding"}
          />
          <Form customcss={true} course={"fullstack"}/>
        </div>
      </div>
      <Testimonial />
      <Feature track={track} duration={duration} />
      <BecomeProfessional track={track} content={content} displayForm={displayForm}/>
      <LearningEnvironment displayForm={displayForm}/>
      <TrackTimeline tracks={tracks} displayForm={displayForm}/>
      <WhyChooseGeegStack />
      <CareerSupport track={track}/>
      <div className="get-pack">
        <p>
          Interested in what you'll learn during the course of this program ?
        </p>
        <button onClick={displayForm}>Get Program Package</button>
      </div>
      <Faq faqs={faqs} displayForm={displayForm} />
      <Pricing pricing={pricing} displayForm={displayForm} />
    </div>
  );
}

function CourseInfo({
  courseName,
  courseDescription,
  duration,
  startDate,
  modes
}) {
  return (
    <div className="course_info">
      <div className="coursename">
        <h1 className="course-name">{courseName}</h1>
        <p className="course-description">{courseDescription}</p>
      </div>
      <div className="enrollement-details">
        <div className="enrollement-details-content">
          <h3>Enrollment Details</h3>
          <div>
            <div className="enrollement-detail">
              <p>
                <FontAwesomeIcon icon={faLocationDot} /> Location
              </p>
              <p style={{textAlign: "right"}}>70/80, Oyo road, Opposite University <br/>of Ibadan Second gate, Ibadan.</p>
            </div>
            <div className="enrollement-detail">
              <p>
                <FontAwesomeIcon icon={faCalendarDays} /> Start Date
              </p>
              <p>{startDate}</p>
            </div>
            <div className="enrollement-detail">
              <p>
                <FontAwesomeIcon icon={faClock} /> Duration
              </p>
              <p>{duration}</p>
            </div>
            <div className="enrollement-detail">
              <p>
                <FontAwesomeIcon icon={faCalendar} /> Modes
              </p>
              <p>{modes}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
